
import React from 'react';
import { useSelector } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { getAttributeById } from '../../common/common/iskn/dataDefinition';
import { DEFINITION_TEL } from '../../common/common/iskn/tel';

import { getParamsValues  } from '../../reducers/search';

import FilterBase from './FilterBase';
import FilterItemText from './FilterItemText';
import FilterItemValues from './FilterItemValues';

const FilterContent = () => {

    const paramsValues = useSelector(state => getParamsValues(state.search));

    return (
        <FilterBase
            objectType={DEFINITION_TEL.objectType}
            items={[
                <FilterItemValues
                    definition={{
                        id: 'katuze_kod',
                        title: 'Katastrální území',
                        values: paramsValues.katuze.map(item => [item.kod, item.nazev])
                    }}
                />,

                <FilterItemText definition={getAttributeById(DEFINITION_TEL, 'cislo_tel')} />
            ]}
        />
    );
}

const TelFilter = () => {
    return (
        <Stack>
            <FilterContent />
        </Stack>
    );
}

export default TelFilter;
